import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import AuthContext from '../contexts/AuthContext';

const BASE = 'py-3 text-xs font-bold uppercase tracking-[0.08em]';
const ACTIVE = 'text-accent border-b-2 border-accent -mb-[1px]';
const INACTIVE = 'text-surface-muted hover:text-surface-text';
const DISABLED = 'text-surface-border cursor-not-allowed';

export default function TabBar() {
  const { role } = useContext(AuthContext);
  const isManager = role === 'manager';

  const tab = (to, label, disabled = false) => {
    if (disabled) {
      return <span className={`${BASE} ${DISABLED}`} title="Manager-only">{label}</span>;
    }
    return (
      <NavLink
        to={to}
        className={({ isActive }) => `${BASE} ${isActive ? ACTIVE : INACTIVE}`}
      >
        {label}
      </NavLink>
    );
  };

  return (
    <nav className="px-6 bg-surface-header border-b border-surface-border flex gap-8">
      {tab('/accounts', 'Accounts')}
      {tab('/activity', 'Activity')}
      {tab('/codes', 'Codes', !isManager)}
      {tab('/users', 'Users', !isManager)}
      {tab('/settings', 'Settings')}
    </nav>
  );
}
